import { useQuery } from '@tanstack/react-query';
import { DEVICE_REGISTRATION_DATE } from '../../utils/constants/queryKeys';
import { getUserDeviceRegistrationDate } from '../services/fn-api/User';

export const useGetDeviceRegistrationDate = (userId: number) => {
  return useQuery({
    queryKey: [DEVICE_REGISTRATION_DATE, userId],
    queryFn: () => getUserDeviceRegistrationDate(userId),
    enabled: !!userId,
  });
};
